export const modal = () => {
    const $ = jQuery;
    
    const triggers = $('#modal-trigger, #modal-close');
    const overlay = $('#modal-overlay');

    triggers.on('click', () => {
        $('body').toggleClass('show-modal');
        overlay.toggleClass('show');
    });
};